import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
export function BookingsScreen() {
  return <div className="h-screen w-full flex flex-col bg-gray-50" data-id="element-412">
      <Header title="My Bookings" showLogo={true} data-id="element-413" />

      <div className="flex-1 overflow-hidden bg-gray-50 flex items-center justify-center p-6" data-id="element-414">
        <div className="text-center max-w-md" data-id="element-415">
          <div className="w-20 h-20 mx-auto mb-6 bg-[#3dc7e3]/10 rounded-full flex items-center justify-center" data-id="element-416">
            <CalendarIcon className="w-10 h-10 text-[#3dc7e3]" data-id="element-417" />
          </div>
          <h2 className="text-2xl font-bold text-[#1f5070] mb-3" data-id="element-418">
            No bookings found
          </h2>
          <p className="text-[#666666] text-lg" data-id="element-419">
            Once you make a booking, it will appear here.
          </p>
        </div>
      </div>

      <BottomNav data-id="element-420" />
    </div>;
}